import React from 'react';

const Icon170OrientationConfiguration2Recliner = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <g>
      <rect
        x="508.37"
        y="264.96"
        width="216.75"
        height="216.75"
        transform="translate(1233.5 746.66) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M734.3,212.71h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        transform="translate(1492.1 694.42) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M508.37,212.71h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        transform="translate(1233.5 477.67) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M508.37,481.71h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <rect
        x="291.63"
        y="264.96"
        width="216.75"
        height="216.75"
        transform="translate(800 746.66) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <rect
        x="291.63"
        y="212.71"
        width="216.75"
        height="52.25"
        transform="translate(800 477.67) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </g>
    <g>
      <rect
        x="74.88"
        y="264.96"
        width="216.75"
        height="216.75"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M42.2,212.71h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M83.88,212.71h198.75c4.97,0,9,4.03,9,9v43.25H74.88v-43.25c0-4.97,4.03-9,9-9Z"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M83.88,481.71h198.75c4.97,0,9,4.03,9,9v43.25H74.88v-43.25c0-4.97,4.03-9,9-9Z"
        transform="translate(366.5 1015.66) rotate(180)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
    </g>
    <line
      x1="508.37"
      y1="264.96"
      x2="508.37"
      y2="481.71"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon170OrientationConfiguration2Recliner;
